function setParameters(term) {
  // Get the current URL
  var currentUrl = window.location.href;

  // Remove the old attributes from the URL
  currentUrl = currentUrl.replace(/(\?|&)term=[^&]+/gi, '');

  // Construct the updated URL with new attributes
  var separator = currentUrl.indexOf('?') !== -1 ? '&' : '?';
  var updatedUrl = currentUrl + separator + 'term=' + term;

  // Update the URL
  window.history.pushState(null, null, updatedUrl);
}

// Get the URL parameters
var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

  for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
  }
  return false;
};

// Check if the term parameter is set
var term = getUrlParameter('term');
if(term && $('.post-filter__items').length) {
  $('.post-filter__items__term').removeClass('active');
  
  // Set the active term
  $('.post-filter__items__term[data-term="'+term+'"]').addClass('active');

  // Load posts
  loadPosts(term);
}

// Load posts
function loadPosts(term) {
  $('.post-filter-empty').hide();
  $('.post-filter-results').hide().html('');
  $('.post-filter-spinner').show();

  // Get the taxonomy and post type from the hidden inputs
  var taxonomy = $('input[name="post-filter-taxonomy"]').val();
  var post_type = $('input[name="post-filter-post_type"]').val();
  var page = $('input[name="post-filter-page"]').val();
  var slug = $('input[name="post-filter-slug"]').val();
  var selected = $('input[name="post-filter-selected"]').val();

  $.ajax({
    type: 'POST',
    url: myGlobalData.ajaxurl, // eslint-disable-line
    data: {
      action: 'filter_posts',
      post_type: post_type,
      selected: selected,
      taxonomy: taxonomy,
      page: page,
      term: term,
      slug: slug,
    },
    success: function(response) {
      // Delay the response to show the spinner
      setTimeout(function() {
        if (response.success) {
          $('.post-filter-results').show().html(response.data);
        } else {
          $('.post-filter-results').html('');
          $('.post-filter-empty').show();
        }
        $('.post-filter-spinner').hide();
      }, 500);
    },
  });
}

// Filter posts on click of term item in the filter bar
$(document).on('click', '.post-filter__items__term', function() {
  //remove /page/x from url
  var currentUrl = window.location.href;
  currentUrl = currentUrl.replace(/\/page\/[0-9]+\//gi, '');
  window.history.pushState(null, null, currentUrl);

  $('input[name="post-filter-page"]').val(1);

  $('.post-filter__items__term').removeClass('active');

  // Set the active term
  $(this).addClass('active');

  // Get the term
  var term = $(this).attr('data-term');

  // Set the URL parameters
  setParameters(term);

  // Load posts
  loadPosts(term);
});

$( window ).on( 'load', function() {
  if($('.archive-posts').length){
    var term = getUrlParameter('term');
    if(!term){
      loadPosts('all');
    }
  }
});

$( window ).on('load', function() {
  // Check if the load parameter is set
  var load = getUrlParameter('load');
  if(load && $('.post-filter__items').length) {
    // Scroll to the filter bar when url has parameter load after click on pagination
    $('html, body').animate({
      scrollTop: $('#post-filter').offset().top  - $('header').outerHeight(),
    }, 0, 'swing');

    // remove load parameter from url
    var newURL = window.location.href.replace(/[?&]load=([^&#]*)/, '');
    history.replaceState(null, '', newURL);
  }
});
